// This file is auto-generated using the 'icon-generator' package.
// Any changes made to this file manually will be lost the next time the
// file is generated

import * as React from "react";
import { MappedProps, PassedProps, useMappedProps } from "./useMappedProps";

const Icon: React.ComponentType<
  Omit<React.SVGProps<SVGSVGElement>, keyof MappedProps> & PassedProps
> = (passedProps) => {
  const props = useMappedProps(passedProps);
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        d="M11.752 3.036a.88.88 0 0 0-.439.396c-.044.082-.045.236-.051 5.291l-.006 5.208-1.65-1.648C7.752 10.43 7.842 10.507 7.5 10.507c-.42 0-.74.318-.743.737-.002.34-.176.143 2.455 2.777 2.63 2.633 2.452 2.476 2.788 2.476.336 0 .159.157 2.788-2.476 2.64-2.644 2.457-2.435 2.455-2.789a.572.572 0 0 0-.06-.297.739.739 0 0 0-.683-.428c-.342 0-.252-.076-2.106 1.776l-1.65 1.647-.006-5.207-.006-5.207-.052-.097a.935.935 0 0 0-.363-.351.903.903 0 0 0-.565-.032M.456 15.062a.82.82 0 0 0-.38.358l-.064.12-.008.924c-.008.999.01 1.287.106 1.683a3.776 3.776 0 0 0 2.248 2.584c.282.113.651.207.953.244.283.035 17.095.035 17.378 0 1.28-.157 2.358-.925 2.947-2.102a4.1 4.1 0 0 0 .306-.988c.02-.141.048-.29.06-.33.03-.104.03-1.986-.002-1.967-.013.008-.024-.005-.024-.029 0-.07-.092-.226-.196-.334a.679.679 0 0 0-.488-.22.741.741 0 0 0-.728.446l-.064.137-.014 1.032-.013 1.032-.065.21c-.123.404-.32.729-.607 1.003a2.242 2.242 0 0 1-.938.545l-.211.066H3.348l-.21-.066c-.774-.243-1.312-.782-1.546-1.547-.064-.21-.065-.213-.08-1.243-.01-.568-.026-1.059-.037-1.092a.954.954 0 0 0-.253-.362.75.75 0 0 0-.766-.104m-.445 1.51c0 .541.003.766.007.5.004-.267.004-.71 0-.984-.004-.275-.007-.057-.007.484"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
};

const DownloadIcon = Icon;
export default DownloadIcon;
